<div class="transport-details-list-entry">
  <div class="information">
    <div class="info-button">
      <app-transport-details-dialog-action [transport]="transport.transport" [asButton]="true"
      (onChange)="triggerUsageRefresh()" [dashboardContext]="dashboardContext"></app-transport-details-dialog-action>
      <!-- <button mat-stroked-button (click)="showTransportInfos()"><sc-icon iconClass="fa-info"></i></button> -->
    </div>
    @if (transport) {
      <div class="row">
        <app-transport-details [mode]="TransportDetailMode.READONLY" [layout]="layoutDefinition"
          [transport]="transport.transport">
        </app-transport-details>
      </div>
    }
  </div>

  <div class="actions">
    @for (mk of transport.messageKeys; track mk) {
      <div class="notification">
        <sc-dictionary-label [dictionaryKey]="mk"></sc-dictionary-label>
      </div>
    }
    @if (featureUmbrueckungEnabled && transport.completeUmbrueckungAllowed && transport.completeUmbrueckungEnabled) {
      <div class="notification"
        >
      <div [innerHTML]="'the trailer of the selected transport of currently beeing swapped, you can cancel or complete this process.' | translate: ['tmc-yard.ui.control.sac-client.complete-umbrueckung-dialog.info-text', translationService.language, translationService.revision] |
      trustHtml">
        </div>
      </div>
    }
    @if (transport.assignAllowed) {
      <sc-flex>
        <sc-button primary (click)="assignTransportToStation()" class="grow"
        dictionaryKey="tmc-yard.ui.control.sac-client.transport-details-list-entry.action.assign"></sc-button>
      </sc-flex>
    }
    @if (featureMovingOrderActive) {
      @if (transport.createMovementOrderAllowed) {
        <div class="action-bar">
          <sc-button mat-flat-button (click)="createMovementOrder()"
          dictionaryKey="tmc-yard.ui.control.sac-client.transport-details-list-entry.action.create-moving-order"></sc-button>
        </div>
      }
    }
    @if (station?.stationUsage?.plannedTransportAssignmentPossible && station?.stationUsage?.transports.length>0 && !transport.plannedForAssignment) {
      <div class="action-bar"
        >
        <sc-button mat-flat-button (click)="planAssignment()"
          dictionaryKey="tmc-yard.ui.control.sac-client.transport-details-list-entry.action.plan-assignment">
        </sc-button>
      </div>
    }
    @if (featureUmbrueckungEnabled) {
      @if (transport.startUmbrueckungAllowed) {
        <div class="action-bar">
          <sc-button mat-flat-button (click)="startUmbrueckung()" [disabled]="!transport.startUmbrueckungEnabled"
            dictionaryKey="tmc-yard.ui.control.sac-client.transport-details-list-entry.action.start-umbrueckung">
          </sc-button>
        </div>
      }
      @if (transport.completeUmbrueckungAllowed) {
        <div class="action-bar">
          <sc-button mat-stroked-button (click)="cancelUmbrueckung()" [disabled]="!transport.completeUmbrueckungEnabled"
            dictionaryKey="tmc-yard.ui.control.sac-client.transport-details-list-entry.action.cancel-umbrueckung">
          </sc-button>
          <div class="spacer"></div>
          <sc-button mat-flat-button (click)="completeUmbrueckung()" [disabled]="!transport.completeUmbrueckungEnabled"
            dictionaryKey="tmc-yard.common.action.finish">
          </sc-button>
        </div>
      }
    }
  </div>
</div>
